<template>
    <v-alert v-if="paymentFailed" dark color="pink darken-1" dense v-ripple class="pointer" border="left"
        icon="mdi-credit-card-sync-outline" @click="goToChangePaymentMethod">
        <div class="body-1 bolder">
            {{ title }}
        </div>
        <div class="bottom-text" v-if="nextIntentDate">
            {{ nextIntentDate }}
        </div>
        <div class="bottom-text">
            {{ $t('payment_failed_messages.contact_with_bank') }}
        </div>
        <div v-if="accountDisabled" class="bottom-text bolder">
            {{ accountDisabled }}
        </div>
    </v-alert>
    <v-alert v-else-if="isFremiumPlan" dark color="pink darken-1" dense v-ripple class="pointer" border="top">
        <div class="body-2 text-center">
            {{ $t('payment.freemium_end_title') }}
        </div>
        <v-row>
            <v-col :cols="showRedirect ? 6 : 12" class="text-center">
                <v-btn small class="normal-btn mt-1" @click="showFreemiumEndDialog">
                    {{ $t('common.more_information') }}
                </v-btn>
                <freemium-end-dialog ref="freemiumEnd"/>
            </v-col>
            <v-col cols="6" class="text-center" v-if="showRedirect">
                <v-btn small class="normal-btn mt-1" @click="goToChange">
                    {{ changeLabelButton }}
                </v-btn>
            </v-col>
        </v-row>
    </v-alert>
</template>

<script>
import FreemiumEndDialog from '../common/FreemiumEndDialog.vue'

export default {
  components: { FreemiumEndDialog },
    name: "SubscriptionStatus",
    computed: {
        currentSubscription(vm = this) {
            return vm.account?.stripeAccount?.currentSubscription || null
        },
        paymentFailed(vm = this) {
            if (!vm.currentSubscription) return false
            return Boolean(vm.currentSubscription.paymentFailed)
        },
        isFremiumPlan(vm = this) {
            return vm.currentSubscription?.priceId === 'price_1KlzRsEO5hTr6qAY4WRvQizn'
        },
        changePaymentRoute(vm = this) {
            return `${vm.accountType}.payment.edit`
        },
        changePlanRoute(vm = this) {
            return `${vm.accountType}.select-plan`
        },
        showRedirect(vm = this) {
            return vm.$route.name !== vm.changePaymentRoute && vm.$route.name !== vm.changePlanRoute
        },
        title(vm = this) {
            let defaultMessage = vm.$t('payment_failed_messages.try_again_later')
            let failed = vm.account?.stripeAccount?.failedReason || ''
            if (!failed) return defaultMessage
            return vm.$te(`payment_failed_messages.${failed}`) ?
                vm.$t(`payment_failed_messages.${failed}`) :
                defaultMessage
        },
        nextIntentDate(vm = this) {
            let date = vm.account?.stripeAccount?.currentSubscription?.nextPaymentAttempt || null
            if (!date) return null
            let dateMoment = vm.$moment(date * 1000)
            if (dateMoment.isBefore()) return null
            let dateFormat = dateMoment.format(`D [${vm.$t('common.of')}] MMMM [${vm.$t('common.of_the')}] YYYY`)
            return vm.$t('payment_failed_messages.intent_date', { date: dateFormat })
        },
        accountDisabled(vm = this) {
            let today = vm.$moment();
            let daysUntilNextMonday = (8 - today.isoWeekday()) % 7;
            if (daysUntilNextMonday === 0) daysUntilNextMonday = 7;
            let nextMonday = today.add(daysUntilNextMonday, 'days');
            let formattedDate = nextMonday.format('DD-MM-YYYY');
            return vm.$t('payment_failed_messages.account_disabled', { date: formattedDate })
        },
        changeLabelButton(vm = this) {
            if (vm.account?.stripeAccount?.paymentMethod) return vm.$t('common.change_plan')
            return vm.$t('common.change_card')
        }
    },
    methods: {
        goToChangePaymentMethod() {
            const vm = this
            if (!vm.showRedirect) return;
            vm.$router.push({ name: vm.changePaymentRoute })
        },
        showFreemiumEndDialog() {
            const vm = this;
            vm.$refs.freemiumEnd.show()
        },
        goToChange() {
            const vm = this;
            if (!vm.showRedirect) return;
            if (vm.account?.stripeAccount?.paymentMethod) return vm.$router.push({ name: vm.changePlanRoute })
            vm.$router.push({ name: vm.changePaymentRoute })
        }
    }
}
</script>

<style scoped>
.bottom-text {
    line-height: 15px;
    font-size: .75em !important;
    margin: 5px 0;
}
</style>